import React, { useState } from 'react';
import axios from 'axios';
import { useModal } from '../context/ModalContext';
import ImageUpload from './ImageUpload';
import CustomSelect from './CustomSelect';
import '../styles/Modal.css';

const CreateOrganizationModal = ({ onClose, onSuccess, clients, apiPrefix }) => {
  const modal = useModal();
  const [organizationForm, setOrganizationForm] = useState({
    organization_name: '',
    owner_id: '',
    icon_url: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const safeString = (value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${apiPrefix}/create-organization`, organizationForm, { withCredentials: true });
      modal.success('Organization created successfully!');
      setOrganizationForm({ organization_name: '', owner_id: '', icon_url: '' });
      if (onSuccess) await onSuccess(response.data?.organization_id);
      onClose();
    } catch (error) {
      console.error('Error creating organization:', error);
      modal.error(error.response?.data?.error || 'Failed to create organization');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">Create Organization</h3>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="org-name">Organization Name *</label>
            <input
              type="text"
              id="org-name"
              value={organizationForm.organization_name}
              onChange={(e) => setOrganizationForm({...organizationForm, organization_name: e.target.value})}
              placeholder="Enter organization name"
              required
              disabled={isSubmitting}
            />
          </div>
          <div className="form-group">
            <label htmlFor="org-owner">Organization Owner (Optional)</label>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <CustomSelect
                id="org-owner"
                value={organizationForm.owner_id}
                onChange={(e) => setOrganizationForm({...organizationForm, owner_id: e.target.value})}
                disabled={isSubmitting}
              >
                <option value="" disabled hidden>Select Owner</option>
                {clients.map(client => (
                  <option key={safeString(client._id || client.id)} value={safeString(client._id || client.id)}>
                    {safeString(client.name)} ({safeString(client.email)})
                  </option>
                ))}
              </CustomSelect>
              {organizationForm.owner_id && String(organizationForm.owner_id).trim() !== '' && (
                <button
                  type="button"
                  onClick={() => setOrganizationForm({...organizationForm, owner_id: ''})}
                  disabled={isSubmitting}
                  style={{
                    backgroundColor: 'var(--color-danger-button)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    width: '32px',
                    height: '32px',
                    cursor: 'pointer',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}
                  title="Remove owner"
                >
                  ×
                </button>
              )}
            </div>
            <small>Users can be assigned to this organization after creation</small>
          </div>
          <div className="form-group">
            <ImageUpload
              value={organizationForm.icon_url}
              onChange={(s3_url) => setOrganizationForm({...organizationForm, icon_url: s3_url})}
              onClear={() => setOrganizationForm({...organizationForm, icon_url: ''})}
              label="Organization Icon"
              required={false}
              maxSizeMB={5}
              fileType="organization_icon"
            />
          </div>
          <div className="form-actions">
            <button type="button" className="button-main" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </button>
            <button type="submit" className="button-main" disabled={isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create Organization'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateOrganizationModal;
